import msg from 'lib/message'

import {LoadingIcon} from './icons'

export default function Spinner() {
  return (
    <>
      <style global jsx>{`
        .animate-rotate {
          animation: animate-rotate 2s infinite linear;
        }
        @keyframes animate-rotate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(359deg);
          }
        }
      `}</style>
      <LoadingIcon className='animate-rotate' title={msg('common.loading')} />
    </>
  )
}
